import React, {Fragment} from 'react'
import Media from 'react-media';
import { graphql, StaticQuery, Link } from 'gatsby'
import CurlyArrowDown from '../../assets/curly-arrow-down.svg'
import { logEvent, pushToDataLayer } from '../Analytics'

class DownloadApp extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        const {iPhone} = this.props.query;

        return(
            <section className="testa test-cvd">
                {/* <figure><CurlyArrowDown/></figure> */}
                <h3>Barnens digitala mattelärare. <br/> <a href="javascript:void(0)"> Testa Albert gratis tillsvidare! </a></h3>
                
                <Media query="(max-width: 767px)">
                    {
                        matches =>
                            matches ? (
                                <Link to="/register" onClick={ e => {
                                    logEvent(
                                        `Junior Prova gratis i 30 dagar mobile button`,
                                        `Junior Prova gratis i 30 dagar mobile button was clicked`
                                    )
                                    pushToDataLayer(
                                        'userClick',
                                        'Junior Page Prova Gratis I 30 Dagar Mobile Button',
                                        'Junior Page Prova Gratis I 30 Dagar Mobile Button Was Clicked'
                                    )
                                }                                 
                                } className="prove">PROVA GRATIS TILLSVIDARE</Link>
                            ) : (
                                <Link to="/register"  onClick={e => {
                                    logEvent(
                                        `Junior Prova gratis i 30 dagar desktop button`,
                                        `Junior Prova gratis i 30 dagar desktop button was clicked`
                                    )
                                    pushToDataLayer(
                                        'userClick',
                                        'Junior Page Prova Gratis I 30 Dagar Desktop Button',
                                        'Junior Page Prova Gratis I 30 Dagar Desktop Button Was Clicked'
                                    )
                                }
                            }  className="prove">prova gratis<span className="line">Ordinarie pris 99 kr/mån</span></Link>
                            )
                    }
                </Media>
            </section>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <DownloadApp query={data} {...props}/>
        )}
    />
)